<template>
  <div class="mc-foot">
    <div class="mc-foot-card">
      <div class="mc-foot-card__icon mc-foot-card__icon--msg">
        <feather-icon
          icon="MessageSquareIcon"
          size="22"
        />
      </div>
      <div class="mc-foot-card__body">
        <div class="mc-foot-card__valor">
          {{ totalConversas }}
        </div>
        <div class="mc-foot-card__lbl">
          Número de conversas
        </div>
        <div class="mc-foot-card__hint">
          finalizadas no período
        </div>
        <p class="mc-foot-card__muted">
          <template v-if="outrasResolvidas > 0">
            As outras
            <span class="mc-foot-card__muted-num">{{ outrasResolvidas }}</span>
            estão em
            <strong>resolução humana</strong>
            (finalizadas sem contar em “Resolvidas pelo bot” nem em “Atendimentos transferidos”).
          </template>
          <template v-else>
            Todas as conversas deste total aparecem em “Resolvidas pelo bot” ou em “Atendimentos transferidos”.
          </template>
        </p>
      </div>
    </div>

    <div class="mc-foot-card">
      <div class="mc-foot-card__icon mc-foot-card__icon--bot">
        <feather-icon
          icon="CpuIcon"
          size="22"
        />
      </div>
      <div class="mc-foot-card__body">
        <div class="mc-foot-card__valor">
          {{ resolvidasBot }}
        </div>
        <div class="mc-foot-card__lbl">
          Resolvidas pelo bot
        </div>
        <div class="mc-foot-card__hint">
          sem transferência · só finalizadas
        </div>
        <div
          v-if="variacaoPct > 0"
          class="mc-foot-card__pill"
        >
          ↑ {{ variacaoPct }}% vs período anterior
        </div>
      </div>
    </div>

    <div class="mc-foot-card">
      <div class="mc-foot-card__icon mc-foot-card__icon--up">
        <feather-icon
          icon="CornerUpRightIcon"
          size="22"
        />
      </div>
      <div class="mc-foot-card__body">
        <div class="mc-foot-card__valor">
          {{ transferencias }}
        </div>
        <div class="mc-foot-card__lbl">
          Atendimentos transferidos
        </div>
        <div class="mc-foot-card__hint">
          bot → humano · só finalizados
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardsRodapeBot',
  props: {
    totalConversas: {
      type: Number,
      default: 0,
    },
    resolvidasBot: {
      type: Number,
      default: 0,
    },
    transferencias: {
      type: Number,
      default: 0,
    },
    variacaoPct: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    outrasResolvidas() {
      const t = Number(this.totalConversas) || 0
      const b = Number(this.resolvidasBot) || 0
      const tr = Number(this.transferencias) || 0
      return Math.max(0, t - b - tr)
    },
  },
}
</script>

<style scoped>
.mc-foot {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.1rem;
  margin-top: 0.25rem;
  margin-bottom: 2rem;
}

@media (max-width: 767.98px) {
  .mc-foot {
    grid-template-columns: 1fr;
  }
}

.mc-foot-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.2rem 1.25rem;
  border-radius: var(--mc-radius-md);
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(244, 236, 251, 0.88) 45%,
    rgba(251, 248, 254, 0.98) 100%
  );
  border: 1px solid var(--mc-border);
  box-shadow: var(--mc-shadow-sm);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.mc-foot-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(93, 42, 140, 0.1);
}

.mc-foot-card__icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mc-foot-card__icon--msg {
  background: rgba(123, 63, 228, 0.12);
  color: var(--mc-purple) !important;
}

.mc-foot-card__icon--bot {
  background: rgba(89, 201, 165, 0.18);
  color: #2a9d74 !important;
}

.mc-foot-card__icon--up {
  background: rgba(255, 138, 122, 0.18);
  color: #e85d4c !important;
}

.mc-foot-card__valor {
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  font-size: 1.65rem;
  font-weight: 800;
  color: var(--mc-text);
  line-height: 1.1;
}

.mc-foot-card__lbl {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--mc-text-soft);
  margin-top: 0.35rem;
}

.mc-foot-card__hint {
  font-size: 0.8rem;
  color: var(--mc-text-muted);
  margin-top: 0.15rem;
  font-weight: 500;
}

.mc-foot-card__muted {
  margin: 0.5rem 0 0;
  font-size: 0.72rem;
  line-height: 1.45;
  font-weight: 500;
  color: var(--mc-text-muted);
  opacity: 0.92;
}

.mc-foot-card__muted strong {
  font-weight: 700;
  color: var(--mc-text-soft);
}

.mc-foot-card__muted-num {
  font-weight: 800;
  color: var(--mc-text-muted);
}

.mc-foot-card__pill {
  display: inline-block;
  margin-top: 0.45rem;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 0.2rem 0.55rem;
  border-radius: var(--mc-radius-pill);
  background: rgba(89, 201, 165, 0.2);
  color: #1f8f6a;
}
</style>
